import React from "react";
import {useTranslation} from "react-i18next";
import {Button, ButtonStyles} from "../form/Button/Button";
import Modal from "./Modal";
import {VoucherType} from "@connox/typescript-library/types/cart/VoucherType";

interface IApplicableVouchersProps {
  closeFunction: () => void;
  isVisible: boolean;
  voucherTitle: string;
  voucherType: VoucherType | null;
}

const ApplicableVouchersModal: React.FC<IApplicableVouchersProps> = (props) => {
  const {t} = useTranslation();

  return (
    <Modal isVisible={props.isVisible} closeFunction={props.closeFunction}>
      <h2>{props.voucherTitle}</h2>
      <p>
        {
          /* ACHTUNG: wenn gerade eine Aktion läuft, bei der Prozentgutscheine nicht auf rabattierte Artikel
           * anwendbar sind, muss hier in der ersten Zeile (für Relative Vouchers) der Textbaustein
           * "general.voucherIsNotRedeemableReducedProducts--manufacturers" eingebaut werden */
          props.voucherType === "Relative"
            ? t("general.voucherIsNotRedeemable--manufacturers", {manufacturers: excludedManufacturers})
            : t("general.voucherIsNotRedeemable--manufacturers", {manufacturers: excludedManufacturers})
        }
      </p>
      <p>{t("general.voucherCannotBeCombined")}</p>
      <p>{t("general.voucherCannotBePublished")}</p>
      <div className="center">
        <Button styles={[ButtonStyles.big]} action={props.closeFunction}>
          {t("general.okay")}
        </Button>
      </div>
    </Modal>
  );
};

export default ApplicableVouchersModal;

export const excludedManufacturers =
  " Bolia, Cane-line, Fast, Fatboy, Fermob, Foscarini, Gloster, Kartell, Knoll International, Muuto, Stapelstein, String, Vitra";
